// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Input, Select, Skeleton } from '@/ui';
import { FormItem, IFormInstance } from '@/components';
import { FormColumn, StyledWrapper, StyledButton, StyledFooter } from '../Styled';
import { StyledForm } from './CreateAdminFormStyles';

// Models
import { IAdmin } from '@/models/admins.model';

// Helpers
import { AdminFormFieldsNames, TAdminFormValues } from '../../helpers/types';
import { useAdminFormRules } from '../../hooks';
import { getRoleOptions } from '../../helpers/getOptions';

interface ICreateAdminForm {
  handleSubmit: (values: TAdminFormValues) => void;
  isLoading: boolean;
  id: string | null;
  form: IFormInstance;
  initialValues?: IAdmin | null;
}

const CreateAdminForm = ({ handleSubmit, isLoading, initialValues, form, id }: ICreateAdminForm) => {
  const { t } = useTranslation(['admins', 'common']);
  const rules = useAdminFormRules();

  const placeholder = t('common_placeholder_input', { ns: 'common' });

  if (isLoading) return <Skeleton />;

  return (
    <StyledWrapper>
      <StyledForm onFinish={handleSubmit} initialValues={initialValues ?? {}} form={form} name={'create-form'}>
        <FormColumn>
          <FormItem
            name={AdminFormFieldsNames.NAME}
            label={t('admins_list_name')}
            rules={rules[AdminFormFieldsNames.NAME]}
          >
            <Input placeholder={placeholder} size="large" />
          </FormItem>
          <FormItem
            name={AdminFormFieldsNames.ROLE}
            label={t('admins_list_role')}
            rules={rules[AdminFormFieldsNames.ROLE]}
          >
            <Select options={getRoleOptions(t)} size="large" placeholder={t('admins_list_role')} />
          </FormItem>
          <FormItem
            name={AdminFormFieldsNames.EMAIL}
            label={t('admins_list_email')}
            rules={rules[AdminFormFieldsNames.EMAIL]}
          >
            <Input placeholder={placeholder} size="large" />
          </FormItem>
          <FormItem name={AdminFormFieldsNames.PHONE_NUMBER} label={t('admins_list_phone_number')}>
            <Input placeholder={placeholder} size="large" />
          </FormItem>
        </FormColumn>
      </StyledForm>
      <StyledFooter>
        <StyledButton htmlType="submit" form={'create-form'} type={'primary'} loading={isLoading}>
          {t(id ? 'admin_edit_save' : 'admin_create_save')}
        </StyledButton>
      </StyledFooter>
    </StyledWrapper>
  );
};

export default CreateAdminForm;
